import {createSlice} from '@reduxjs/toolkit';

const labSlice = createSlice({
    name:'lab',
    initialState:{
        refreshKey:0,
    },
    reducers:{
        triggerLabRefresh: (state)=>{
            state.refreshKey= Date.now();
        },
    },
});

export const {triggerLabRefresh} = labSlice.actions;

export default labSlice.reducer;
